<script>
import ProductFormDesktopView from "./ProductFormDesktopView.vue";

/**
 * Desktop product-form layout bridge.
 * Renders ProductFormDesktopView using the parent productForm instance as
 * context so template bindings and $refs stay on product.vue (provide/inject).
 */
export default {
  name: "ProductFormDesktopBridge",
  inject: ["productForm"],
  render() {
    const productForm = this.productForm;
    const viewOptions = ProductFormDesktopView.options || ProductFormDesktopView;
    const render = viewOptions.render;

    if (!productForm || typeof render !== "function") {
      return null;
    }

    const options = productForm.$options;
    const prevStaticRenderFns = options.staticRenderFns;
    const prevScopeId = options._scopeId;

    options.staticRenderFns = viewOptions.staticRenderFns;
    if (viewOptions._scopeId) {
      options._scopeId = viewOptions._scopeId;
    }

    try {
      return render.call(productForm, productForm.$createElement);
    } finally {
      options.staticRenderFns = prevStaticRenderFns;
      options._scopeId = prevScopeId;
    }
  },
};
</script>
